export default __webpack_public_path__ + "static/media/copay.79694b42.svg";